import { StockUnit } from '@/enums/StockUnit';
import { IStockItem } from '@/interfaces/IStockItem';
import { IStockRecipe } from '@/interfaces/IStockRecipe';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

const apiUrl = Globals.apiPath + '/stock/recipes';

export interface ICreateStockRecipeDto {
  restaurantId: number;
  branchId: number;
  stockItemId: number;
  itemId?: number;
  optionId?: number;
  optionItemId?: number;
  quantity: number;
}

export class StockRecipesService {
  static async findByItemId(
    restaurantId: number,
    branchId: number,
    itemId: number
  ) {
    const res = await axios.get<IStockRecipe[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&itemId=${itemId}`
    );
    return res.data;
  }

  static async findByOptionItemId(
    restaurantId: number,
    branchId: number,
    optionItemId: number
  ) {
    const res = await axios.get<IStockRecipe[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&optionItemId=${optionItemId}`
    );
    return res.data;
  }

  static async findByOptionId(
    restaurantId: number,
    branchId: number,
    optionId: number
  ) {
    const res = await axios.get<IStockRecipe[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&optionId=${optionId}`
    );
    return res.data;
  }

  static async findByStockItemId(
    restaurantId: number,
    branchId: number,
    stockItemId: number
  ) {
    const res = await axios.get<IStockRecipe[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&stockItemId=${stockItemId}`
    );
    return res.data;
  }

  /** Every line of the items plus the shared (item-less) lines of the options. */
  static async findForItems(
    restaurantId: number,
    branchId: number,
    itemIds: number[],
    optionIds: number[]
  ) {
    const optionParam =
      optionIds.length > 0 ? `&optionIds=${optionIds.join(',')}` : '';
    const res = await axios.get<IStockRecipe[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&itemIds=${itemIds.join(
        ','
      )}${optionParam}`
    );
    return res.data;
  }

  static async create(stockRecipe: ICreateStockRecipeDto) {
    const res = await axios.post<IStockRecipe>(apiUrl, stockRecipe);
    return res.data;
  }

  static async update(
    id: number,
    {
      quantity,
    }: {
      quantity: number;
    }
  ) {
    const res = await axios.put<IStockRecipe>(`${apiUrl}/${id}`, {
      quantity,
    });
    return res.data;
  }

  static async delete(id: number) {
    const res = await axios.delete<IStockRecipe>(`${apiUrl}/${id}`);
    return res.data;
  }

  static async massUpdate({
    restaurantId,
    branchId,
    toAdd,
    toUpdate,
    toDelete,
  }: {
    restaurantId: number;
    branchId: number;
    toAdd: ICreateStockRecipeDto[];
    toUpdate: { id: number; quantity: number }[];
    toDelete: number[];
  }) {
    const res = await axios.post(`${apiUrl}/mass-update`, {
      restaurantId,
      branchId,
      toAdd,
      toUpdate,
      toDelete,
    });

    return res.data;
  }
}
